module.exports = __webpack_public_path__ + "089e22b9b29a14946e6652f18c8bf382.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room8/audio6/08_6MCA Another Body.mp3
// module id = 798
// module chunks = 0